<template>
  <div>
    <wc-data-box
      title='Resolution'
      titleIcon='mdi-comment-check-outline'
      :showEdit='!invoice.archived && !invoice.is_uncollectible'
      @edit='editResolution'
    >
      <v-card-text>
        <span style='white-space: pre-wrap' v-if='resolution'>{{ resolution }}</span>
        <span v-else class='grey--text'>No resolution set...</span>
      </v-card-text>
    </wc-data-box>

    <wc-dialog
      title='Edit Resolution'
      :showDialog='showDialog'
      @save='saveResolution'
      @cancel='cancel'
    >
      <v-textarea
        outlined
        v-model='resolution'>
      </v-textarea>
    </wc-dialog>
  </div>
</template>

<script>
export default {
  name: 'invoice-resolution',
  props: {
    invoice: {
      required: true
    }
  },
  created () {
    this.resolution = this.invoice.resolution;
  },
  data: () => ({
    resolution: '',
    isLoading: false,
    invoiceCopy: {},
    showDialog: false
  }),
  methods: {
    editResolution () {
      this.resolution_copy = this.resolution;
      this.showDialog = true;
    },
    cancel() {
      this.resolution = this.resolution_copy;
      this.showDialog = false;
    },
    saveResolution () {
      this.$emit('update', this.invoice.id, {'resolution': this.resolution});
      this.showDialog = false;
    }
  }
}
</script>
